import { render, staticRenderFns } from "./ExhibitorsMeeting.vue?vue&type=template&id=2f540a56&scoped=true"
import script from "./ExhibitorsMeeting.vue?vue&type=script&lang=js"
export * from "./ExhibitorsMeeting.vue?vue&type=script&lang=js"
import style0 from "./ExhibitorsMeeting.vue?vue&type=style&index=0&id=2f540a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f540a56",
  null
  
)

export default component.exports